import {fork, actionChannel, take, call, all, delay, race} from "redux-saga/effects";
import {buffers} from "redux-saga";

export const queue = (debounceDelay, minTaskDuration, pattern, task, ...args) => fork(function* () {
    const channel = yield actionChannel(pattern, buffers.sliding(1));

    while (true) {
        let action = yield take(channel);

        while (true) {
            const { debounced, latestAction } = yield race({
                debounced: delay(debounceDelay),
                latestAction: take(pattern),
            });

            if (debounced) {
                if (minTaskDuration) {
                    yield all([
                        delay(minTaskDuration),
                        call(task, ...args, action),
                    ]);
                }
                else {
                    yield call(task, ...args, action);
                }
                break;
            }

            action = latestAction;
        }
    }
});
